var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "row justify-content-between" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.insightparams.percent_view,
                        expression: "insightparams.percent_view"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.insightparams,
                            "percent_view",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.loadInsightProfile
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "7daysago" } }, [
                      _vm._v("7 days ago")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "30daysago" } }, [
                      _vm._v("30 days ago")
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "card-group m-b-30" },
                  [
                    _vm.isLoading
                      ? _c("skeleton", {
                          attrs: { height: "180px", width: "150px" }
                        })
                      : _vm._l(_vm.rows_insight, function(row, idx) {
                          return _c("div", { key: idx, staticClass: "card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between mb-3"
                                  },
                                  [
                                    _c("div", [
                                      _c("span", { staticClass: "d-block" }, [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.renameLabel(idx)
                                            )
                                          }
                                        })
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div")
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.loading_persen
                                  ? _c(
                                      "div",
                                      { staticClass: "mb-3" },
                                      [
                                        _c("skeleton", {
                                          attrs: { height: "1.5rem" }
                                        })
                                      ],
                                      1
                                    )
                                  : [
                                      _c("h3", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          _vm._s(_vm._f("angkaKMB")(row.now))
                                        )
                                      ])
                                    ],
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "progress mb-2",
                                    staticStyle: { height: "5px" }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "progress-bar bg-primary",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        role: "progressbar",
                                        "aria-valuenow": "40",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "mb-0" },
                                  [
                                    _vm.loading_persen
                                      ? _c("skeleton", {
                                          attrs: { height: "40px" }
                                        })
                                      : [
                                          _c(
                                            "span",
                                            {
                                              class: [
                                                _vm.rows_percent[idx] > 0
                                                  ? "text-success"
                                                  : _vm.rows_percent[idx] == 0
                                                  ? "text-secondary"
                                                  : "text-danger"
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.rows_percent[idx] > 0
                                                    ? "+"
                                                    : ""
                                                ) +
                                                  _vm._s(
                                                    _vm.rows_percent[idx]
                                                  ) +
                                                  "%"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.insightparams.percent_view ===
                                          "7daysago"
                                            ? _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("in the last 7 days")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.insightparams.percent_view ===
                                          "30daysago"
                                            ? _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("in the last 30 days")]
                                              )
                                            : _vm._e()
                                        ]
                                  ],
                                  2
                                )
                              ],
                              2
                            )
                          ])
                        })
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "card v-graph" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("h3", { staticClass: "card-title" }, [
                        _vm._v("New Followers")
                      ]),
                      _vm._v(" "),
                      _c("line-chart", {
                        attrs: {
                          id: "line",
                          data: _vm.lineData,
                          xkey: "y",
                          ykeys: '["a"]',
                          labels: '["Follower"]',
                          resize: "true"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c("h3", { staticClass: "page-title" }, [_vm._v("Profile")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eae36b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eae36b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramAnalytics/profile.vue
// module id = null
// module chunks = 